import { faList, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Switch } from "@mui/material";
import React from "react";
import { Form, Button, Col, Row } from "react-bootstrap";

export function RowsCat({
  index,
  enabled,
  nombre,
  lista,
  ingredientes,
  obligatorios,
  OnRemove,
  OnChange,
  OnSelect,
}) {
  return (
    <Row key={index}>
      <Col md={3}>
        <div className="center">
          <label htmlFor="ingredientes" className="mrg-lblshow">
            Nombre de la categoria
          </label>
          <Form.Control
            placeholder="Categoria"
            id="ingredientes"
            className="mrg-costos"
            disabled={enabled}
            onChange={(e) => OnChange(index, e.target.name, e.target.value)}
            value={nombre}
            name="nombre"
            required
            type="text"
          />
        </div>
      </Col>
      <Col md={3}>
        <div className="center">
          <label htmlFor="ingredien" className="mrg-lblshow">
            Cantidad por platillo
          </label>
          <Form.Control
            placeholder="0"
            id="ingredient"
            className="mrg-costos"
            disabled={enabled}
            value={ingredientes ? ingredientes : 0}
            onChange={(e) => OnChange(index, e.target.name, e.target.value)}
            name="ingredientes"
            min={0}
            required
            type="number"
          />
        </div>
      </Col>
      <Col md={2}>
        <div className="center">
          <label htmlFor="Epecificos" className="mrg-lblshow">
            Seleccionar especificos
          </label>
          <Button disabled={enabled} onClick={() => OnSelect(index)}>
            <FontAwesomeIcon icon={faList} />
          </Button>
        </div>
      </Col>
      <Col md={2}>
        <div className="center">
          <label htmlFor="Epecificos" className="mrg-lblshow">
            ¿Obligatorios?
          </label>
          <Switch
            id="obligatorios"
            disabled={enabled}
            onChange={(e) => OnChange(index, e.target.name, !obligatorios)}
            checked={obligatorios}
            name="obligatorios"
          />
        </div>
      </Col>
      <Col md={2}>
        <div className="center">
          <label htmlFor="Epecificos" className="mrg-lblshow">
            Eliminar categoria
          </label>
          <Button disabled={enabled} onClick={() => OnRemove(index)}>
            <FontAwesomeIcon icon={faMinus} />
          </Button>
        </div>
      </Col>
    </Row>
  );
}
